export enum AccessManagementDesignationType {
  USER,
  USER_COLLECTION,
  GROUP,
}
